module.exports = __webpack_public_path__ + "img/AL273HS-1.0b80e8c4.jpg";